const __request = require(`../__request/__request_contentType_json`);

// 国内行程单确认添加
export default (data) => {
    let pParameter = {
        method: 'post',
        urlSuffix: '/buyer/dom/manage/itinerary/update',
        data: data
    }

    return __request(pParameter)
}

